import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError } from '../utils';
import history from '../utils/history';

export const getIdentifierDomains = theSessionId => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    dispatch(getIdentifierDomainsRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/identifier-domains',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(getIdentifierDomainsSuccess(fixAttributes(res.data)));
      })
      .catch(err => {
        dispatch(getIdentifierDomainsFailure(err));
      });
  };
};

export const addIdentifierDomain = domain => {
  const sessionId = getSessionId();
  delete domain['identifierDomainId'];
  return dispatch => {
    axios({
      method: 'POST',
      url: '/openempi-ws-rest/1.0/identifier-domains',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: domain
    })
      .then(res => {
        dispatch(addIdentifierDomainSuccess(res.data));
        history.push('/identifier-domains');
      })
      .catch(err => {
        dispatch(saveIdentifierDomainFailure(err));
      });
  };
};

export const saveIdentifierDomain = (identifierDomainId, domain) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/identifier-domains/' + identifierDomainId,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: domain
    })
      .then(res => {
        dispatch(saveIdentifierDomainSuccess(res.data));
        history.push('/identifier-domains');
      })
      .catch(err => {
        dispatch(saveIdentifierDomainFailure(err));
      });
  };
};

export const deleteIdentifierDomain = identifierDomainId => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'DELETE',
      url: '/openempi-ws-rest/1.0/identifier-domains/' + identifierDomainId,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(deleteIdentifierDomainSuccess(res.data));
      })
      .catch(err => {
        dispatch(saveIdentifierDomainFailure(err));
      });
  };
};

const getIdentifierDomainsRequest = () => {
  return {
    type: Constants.IDDOMAINS_GET_REQUEST
  };
};

const getIdentifierDomainsSuccess = data => {
  return {
    type: Constants.IDDOMAINS_GET_SUCCESS,
    payload: data
  };
};

const getIdentifierDomainsFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.IDDOMAINS_GET_FAILURE,
    payload
  };
};

export const clearIdentifierDomainsError = () => {
  return {
    type: Constants.IDDOMAINS_CLEAR_ERROR
  };
};

const addIdentifierDomainSuccess = data => {
  return {
    type: Constants.IDDOMAINS_ADD_SUCCESS,
    payload: data
  };
};

const saveIdentifierDomainSuccess = data => {
  return {
    type: Constants.IDDOMAINS_SAVE_SUCCESS,
    payload: data
  };
};

const deleteIdentifierDomainSuccess = data => {
  return {
    type: Constants.IDDOMAINS_DELETE_SUCCESS,
    payload: data
  };
};

const saveIdentifierDomainFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.IDDOMAINS_SAVE_FAILURE,
    payload
  };
};

const fixAttributes = domains => {
  const fixedDomains = domains.map(d => {
    if (d.namespaceIdentifier === null) {
      d.namespaceIdentifier = '';
    }
    if (d.universalIdentifier === null) {
      d.universalIdentifier = '';
    }
    if (d.universalIdentifierTypeCode === null) {
      d.universalIdentifierTypeCode = '';
    }
    return d;
  });
  return fixedDomains;
};
